import React from "react";
import { Link } from "react-router-dom";
import Button from "./Button/index";
import moment from "moment";
const currentDate = moment().format("YYYY-MM-DD");

const addButton = (
  {
    assessment_status__status_name,
    id,
    expiry_date,
    respondent_completed,
    batch__min_respondent,
    is_submited,
    instrument__id,
    participant__id,
    instrument__is_multi_rater,
    organisation,
    seller,
    assessment_completed_count,
    enable_report
  },
  handleMouseEnter,
  handleModalClose,
  reportNotification
) => {
  const getModal = localStorage.getItem("Modal Name");
  const isAuthParticipant = localStorage.getItem("is_auth_participant");
  
  if (is_submited && !enable_report) {
    return <Button type="disabled report"> VIEW REPORT </Button>;
  } else if (is_submited && enable_report) {
    // Render the appropriate button when is_submited is true and enable_report is true
    if (isAuthParticipant === 'false' && assessment_status__status_name === "Report in review") {
      return (
        <Link
          to={{
            pathname: `/new/app/reportdownload/${id}/${participant__id}`,
          }}
        >
          <Button type="report"> View Report </Button>
        </Link>
      );
    } else if (assessment_status__status_name === "Completed") {
      return (
        <Link
          to={{
            pathname: `/new/app/reportdownload/${id}/${participant__id}`,
          }}
        >
          <Button type="report"> View Report </Button>
        </Link>
      );
    } else if (assessment_status__status_name === "Report in review" && isAuthParticipant === 'true') {
      return <Button type="disabled report"> View Report </Button>;
    }
  } else if (currentDate > expiry_date) {
    return <Button type="disabled report"> Expired </Button>;
  } else if (
    respondent_completed < batch__min_respondent &&
    assessment_status__status_name === "Completed"
  ) {
    return (
      <Link
        to={{
          pathname: `/new/app/invitations/${id}/${participant__id}/${instrument__is_multi_rater}`,
        }}
      >
        <Button type="start"> Invite Respondents </Button>
      </Link>
    );
  } else if (assessment_status__status_name === "Yet to start") {
    return (
      <Link
        to={{
          pathname: `/new/app/welcome/${instrument__id}/${id}/${organisation}/${seller}/${participant__id}/${instrument__is_multi_rater}/${assessment_completed_count}/assessment`,
        }}
      >
        <Button type="start" style={{ textTransform: 'uppercase' }}> Start </Button>
      </Link>
    );
  } else if (assessment_status__status_name === "In progress") {
    return (
      <Link
        to={{
          pathname: `/new/app/questionnaire/${instrument__id}/${id}/${organisation}/${seller}/${participant__id}/${instrument__is_multi_rater}/${assessment_completed_count}/assessment`,
        }}
      >
        <Button type="resume">Resume</Button>
      </Link>
    );
  } else if (
    (respondent_completed === batch__min_respondent || respondent_completed >= batch__min_respondent) &&
    is_submited === false
  ) {
    return (
      <React.Fragment>
        {getModal == "true" ? (
          <Button
            type="ready"
            handleMouseEnter={handleMouseEnter}
            handleModalClose={handleModalClose}
            reportNotification={reportNotification}
          >
            READY TO SUBMIT
          </Button>
        ) : (
          <Link
            to={{
              pathname: `/new/app/invitations/${id}/${participant__id}/${instrument__is_multi_rater}`,
            }}
          >
            <Button
              type="ready"
              handleMouseEnter={handleMouseEnter}
              handleModalClose={handleModalClose}
              reportNotification={reportNotification}
            >
              READY TO SUBMIT
            </Button>
          </Link>
        )}
      </React.Fragment>
    );
  } else return null;
};

export { addButton };


// WEBPACK FOOTER //
// ./src/new/Utils/addButtons.js